import script from "./MarketplacePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./MarketplacePage.vue?vue&type=script&setup=true&lang=ts"

import "./MarketplacePage.vue?vue&type=style&index=0&id=70dfcc91&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-70dfcc91"]])

export default __exports__